import LetterAvatar from "@/components/Avatar/LetterAvatar"

export const columns = [
  {
    header: "Name",
    cell: ({ row }) => (
      <LetterAvatar name={row.original.name} subtitle={row.original.email} />
    ),
  },
  {
    header: "Email",
    accessorKey: "email",
  },
  {
    header: "Phone",
    accessorKey: "phone",
  },
]
